import { IconType, SvgIcon } from './SvgIcon';

export const SpeakerDisabledIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <g clipPath="url(#clip0_5_1967)">
      <path
        d="M10.6665 6C11.0027 6.44823 11.2206 6.97398 11.2998 7.52867"
        stroke="currentColor"
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9092 3.75732C13.7618 4.6095 14.338 5.69876 14.5627 6.88315C14.7873 8.06754 14.6499 9.29213 14.1685 10.3973"
        stroke="currentColor"
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.3335 1.3335L14.6668 14.6668"
        stroke="currentColor"
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66683 4.6665L4.2755 5.05784C4.18843 5.14542 4.08485 5.21486 3.97076 5.26212C3.85666 5.30938 3.73432 5.33353 3.61083 5.33317H2.00016C1.82335 5.33317 1.65378 5.40341 1.52876 5.52843C1.40373 5.65346 1.3335 5.82303 1.3335 5.99984V9.99984C1.3335 10.1766 1.40373 10.3462 1.52876 10.4712C1.65378 10.5963 1.82335 10.6665 2.00016 10.6665H3.61083C3.73432 10.6661 3.85666 10.6903 3.97076 10.7376C4.08485 10.7848 4.18843 10.8543 4.2755 10.9418L6.53083 13.1978C6.59656 13.2637 6.68037 13.3086 6.77162 13.3268C6.86288 13.3449 6.95748 13.3356 7.04345 13.3C7.12941 13.2644 7.20286 13.204 7.25449 13.1266C7.30613 13.0492 7.33363 12.9582 7.3335 12.8652V7.33317"
        stroke="currentColor"
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.55176 2.78154C6.61568 2.71737 6.69722 2.67363 6.78603 2.65586C6.87485 2.63809 6.96694 2.64709 7.05063 2.68173C7.13432 2.71636 7.20585 2.77507 7.25613 2.8504C7.30642 2.92573 7.3332 3.0143 7.33309 3.10487V3.56221"
        stroke="currentColor"
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1967">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);

SpeakerDisabledIcon.displayName = 'SpeakerDisabledIcon';
